

















































import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import {SelectOption} from '@/types/core';

import tippy from 'tippy.js';

@Component({})

export default class EditableSelect extends Vue {

  @Prop({default:'',type: String}) value!:string;
  @Prop({default:'',type: String}) label!:string;
  @Prop({default: false, type: Boolean}) editing!:boolean;
  @Prop({default: false, type: Boolean}) busy:boolean|undefined;
  @Prop({default: '<Enter text here>', type: String}) placeholder:string|undefined;
  @Prop({default: () => [], type: Array}) selectOptions?: SelectOption[];

  localValue:string = '';
  localLabel:string = '';

  saving:boolean = false;

  public $refs!: {
    editableSelect: any
  };

  mounted(){
    this.localValue = this.value;
    this.localLabel =  (this.mapValueToLabel() as SelectOption).label as string;

    tippy('[data-tippy-content]', {
      arrow: true
    });
  }

  @Watch('value')
  onValueChange(newValue:string, oldValue:string){
    // if (newValue !== oldValue){
      this.localValue = newValue;
      this.localLabel = (this.mapValueToLabel() as SelectOption).label;
    // }
  }

  @Watch('editing')
  onEditingChange(newValue:string, oldValue:string){
    if (newValue){
      this.edit()
    }

     tippy('[data-tippy-content]', { arrow: true });
  }

  async save(){
    this.$emit('edit', false)
    this.$emit('input',this.localValue)
    this.saving = false
  }

  async remove() {
    this.localValue = '';
    this.localLabel = '';
    this.saving = false;
    this.$emit('input','');
  }

  cancel(){
    if (this.saving){
      return
    }
    this.localValue = this.value;
    this.$emit('edit', false);
  }

  toggleEdit(){
    this.$emit('edit', true);
  }

  async edit(){
    await Vue.nextTick();
    this.getFocus();
  }

  getFocus(){
    this.$refs.editableSelect.$el.querySelector('input').focus();
  }


  mapValueToLabel():string | SelectOption {
    if (!(this.selectOptions && this.selectOptions.length)) {
      return this.localValue;
    }
    const filteredOption = this.selectOptions.filter( opt => opt.value === this.localValue );
    if (filteredOption.length) {
      return filteredOption[0];
    }
    return this.localValue;
  }

  handleInput(ev?:SelectOption){
    this.saving = true;
    if (!ev){
      return this.cancel()
    }
    this.localValue = ev.value ? ev.value : '';
    this.localLabel = ev.label ? ev.label : '';
    this.save()
  }
}

